module.exports = __webpack_public_path__ + "media/univerahealthcare-perks@lg-268153f6fe6dd581c31377b935ec637a.jpg";